<div id="webshop" class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true" [ngClass]="webshopNavigations.length > 1 ? '' : 'center-tab'"
    [enableNavigateBackButton]="canNavigateBack()" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <nav mat-tab-nav-bar class="ya-tab-nav-bar">
      <a mat-tab-link *ngFor="let webshopstep of webshopNavigations" [active]="activeLink == webshopstep" disabled
        [@shake]="states['state'+ webshopstep]" (click)="(activeLink!=webshopstep) && ShakeLabel('state'+ activeLink)">
        <span [langkey]="webshopstep"></span>
      </a>
    </nav>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <mat-tab-group [(selectedIndex)]="matGroupSelectedIndex" animationDuration="20ms">
      <mat-tab label="First">
        <ya-basket #basket class="ya-tab-content-wrapper" (onContinue)="onContinue_basket($event)"></ya-basket>
      </mat-tab>
      <ng-container *ngIf="withCheckout">
        <ng-container *ngIf="getCustomerData">
          <mat-tab label="Second">
            <ya-customerData #customerData class="ya-tab-content-wrapper second"
              (onContinue)="onContinue_customerData($event)"></ya-customerData>
          </mat-tab>
        </ng-container>
        <mat-tab label="Third">
          <div class="ya-tab-content-wrapper third">
            <ya-checkout #checkout (navigateToBasket)="onNavigateToBasket()"></ya-checkout>
          </div>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </div>
</div>